<template>
  <div>
    <el-container class="px-3 mt-4">
      <div>
        <search @onSearch="onSearch" :show_all_mvm="true">
          <el-form-item v-if="$route.meta.action.e" label=" ">
            <ExportExcel :export-data="exportData" :columns="columns" :filename="excel_filename" @onExportClick="onExportClick" @clearData="exportData.rows = null" />
          </el-form-item>
        </search>
      </div>
    </el-container>
    <el-row>
      <el-col :xs="24" :sm="24" :lg="24">
        <div v-if="loaded" class="chart-wrapper">
          <bar-chart :chart-data="chartData" :title="'銷售彙總'" :label="chartLabels" :height="`35vh`" />
        </div>
      </el-col>
    </el-row>

    <el-table v-loading="is_loading" :data="mvms" style="width: 100%" stripe :default-sort="{ prop: 'asset_no', order: 'aescending' }">
      <el-table-column prop="asset_no" label="機台編號" width="100" sortable />
      <el-table-column prop="company_name" label="經銷商" width="160" />
      <el-table-column prop="customer_name" label="客戶名稱" width="120" />
      <el-table-column prop="location_name" label="擺放位置" width="120" />
      <el-table-column prop="product_total_volume" label="銷售數量" width="80" />
      <el-table-column prop="total_amount" label="銷售總金額" width="120" sortable />
      <el-table-column prop="cash_amount" label="現金" width="100" sortable />
      <el-table-column prop="easycard_amount" label="悠遊卡" width="100" sortable />
      <el-table-column prop="ipass_amount" label="一卡通" width="100" sortable />
      <el-table-column prop="linepay_amount" label="LinePay" width="100" sortable />
      <el-table-column prop="linepay_ipass_amount" label="LinePay一卡通" width="140" sortable />
      <el-table-column prop="pi_amount" label="Pi行動錢包" width="120" sortable />
      <el-table-column prop="alipay_amount" label="支付寶" width="100" sortable />
      <el-table-column prop="jkos_amount" label="街口" width="100" sortable />
      <el-table-column prop="gamapay_amount" label="橘子支" width="100" sortable />
      <el-table-column prop="taiwanpay_amount" label="台灣Pay" width="100" sortable />
      <el-table-column prop="esunwallet_amount" label="玉山錢包" width="100" sortable />
      <el-table-column prop="pluspay_amount" label="全盈支付" width="100" sortable />
      <el-table-column prop="easycard_esun_amount" label="悠遊付" width="100" sortable />
      <el-table-column prop="creditcard_amount" label="信用卡" width="100" sortable />
    </el-table>
  </div>
</template>
<script>
import { searchMvmSales, v2GetSum } from '@/api/transaction';
import ExportExcel from '@/components/ExportExcel/index.vue';
import BarChart from '@/components/Chart/BarChart';
import search from './components/search.vue';
const moment = require('moment');
const methods = {
  async onSortChange(ordering) {
    if (!ordering.prop || !ordering.order) {
      return;
    }
    try {
      this.sale_ordering.prop = ordering.prop;
      if (ordering.order == null) {
        this.sale_ordering = null;
      } else if (ordering.order == 'descending') {
        this.sale_ordering.order = 'DESC';
      } else {
        this.sale_ordering.order = 'ASC';
      }
      this.currentPage = 1;
      this.onCurrentPageChange(1);
      await this.updatePage();
    } catch (error) {
      console.error('onSortChange error');
      console.error(error);
    }
  },
  async onSizeChange(size) {
    this.size = size;
    await this.updatePage();
  },
  async onCurrentPageChange(page) {
    this.page = page;
    await this.updatePage();
  },
  async updatePage() {
    // console.log(`mvms, updatePage condition: ${JSON.stringify(this.condition)}`);
    this.mvms = await v2GetSum(this.condition, { size: this.size, page: this.page });
  },
  async onExportClick() {
    let now = moment();
    this.excel_filename = `${now.format('YYYYMMDDHHmmss')} 銷售彙總`;
    this.exportData = await v2GetSum(this.condition, {
      size: 1000000,
      page: 1,
    });
    this.is_loading = false;
  },
  async onSearch(condition) {
    // console.log('onSearch received', condition);
    this.is_loading = true;
    this.condition = condition;
    this.mvms = await v2GetSum(this.condition, { size: this.size, page: this.page });
    this.is_loading = false;
  },
  async search(page = 1) {
    try {
      this.mvms = await searchMvmSales(this.condition, page);
      this.is_loading = false;
    } catch (error) {}
  },

  //deprecated
  getSummaries({ columns, data }) {
    const types = this.types;
    const sums = [];

    columns.forEach((col, index) => {
      if (index === 0) {
        sums[index] = '合計';
      }
      if (col.property === 'saleTotal') {
        sums[index] = 0;
        data.forEach((item) => {
          sums[index] += item[col.property];
        });
      }
      if (col.property === 'SaleQt') {
        sums[index] = 0;
        data.forEach((item) => {
          sums[index] += item[col.property];
        });
      }

      for (const type in types) {
        if (col.property === type) {
          sums[index] = 0;
          data.forEach((item, index2) => {
            sums[index] += item[col.property] ? item[col.property] : 0;
          });
        }
      }
    });
    return sums;
  },
};
export default {
  components: {
    ExportExcel,
    BarChart,
    search,
  },
  data() {
    return {
      exportData: [],
      loaded: false,
      condition: {},
      excel_filename: '',
      mvms: [],
      is_loading: true,
      currentPage: 1,
      size: 1000000,
      page: 1,
      sale_ordering: { prop: 'asset_no', order: 'DESC' },
      columns: [
        { field: 'asset_no', label: '機台編號' },
        { field: 'company_name', label: '經銷商' },
        { field: 'customer_name', label: '客戶名稱' },
        { field: 'location_name', label: '擺放位置' },
        { field: 'product_total_volume', label: '銷售數量' },
        { field: 'total_amount', label: '銷售總金額' },
        { field: 'cash_amount', label: '現金' },
        { field: 'easycard_amount', label: '悠遊卡' },
        { field: 'ipass_amount', label: '一卡通' },
        { field: 'linepay_amount', label: 'LinePay' },
        { field: 'linepay_ipass_amount', label: 'LinePay一卡通' },
        { field: 'pi_amount', label: 'Pi行動錢包' },
        { field: 'alipay_amount', label: '支付寶' },
        { field: 'jkos_amount', label: '街口' },
        { field: 'gamapay_amount', label: '橘子支' },
        { field: 'taiwanpay_amount', label: '台灣Pay' },
        { field: 'esunwallet_amount', label: '玉山錢包' },
        { field: 'pluspay_amount', label: '全盈支付' },
        { field: 'easycard_esun_amount', label: '悠遊付' },
        { field: 'creditcard_amount', label: '信用卡' },
      ],

      types: {
        cash: '現金',
        easycard: '悠遊卡',
        easycard_esun: '悠遊付',
        icash: 'icash',
        ipass: '一卡通',
        creditcard: '信用卡',
        line: 'LINE Pay',
        jkos: '街口支付',
        ali: '支付寶',
        gama: '橘子支',
        wechart: '微信支付',
        pi: 'Pi錢包',
        wallet: '玉山錢包',
        pxpay: '全支付',
        family: '全盈支付',
      },
    };
  },
  computed: {
    mvmSalesSumByType() {
      const datas = [];
      if (this.mvms.rows) {
        const mvms = this.mvms.rows;
        for (const mvm of mvms) {
          mvm.SaleQt = 0;
          mvm.saleTotal = 0;

          for (const sale of mvm.sales) {
            try {
              if (sale.PayAmt) {
                if (!mvm[sale.PayType]) {
                  mvm[sale.PayType] = 0;
                }
                mvm[sale.PayType] = mvm[sale.PayType] + parseInt(sale.PayAmt) - parseInt(sale.PayAmtChange);
                mvm.SaleQt += sale.SaleQt;
                mvm.saleTotal = mvm.saleTotal + parseInt(sale.PayAmt) - parseInt(sale.PayAmtChange);
              }
              // console.log(JSON.stringify(mvm));
            } catch (error) {
              console.error(`mvmSaleSumByType error: ${error}`);
            }
          }
          datas.push(mvm);
        }
        // this.loaded = true
      }
      return datas;
    },
    chartData() {
      const data = this.mvmSalesSumByType.map((obj) => {
        this.loaded = true;
        return obj.saleTotal;
      });
      const chartData = {
        data,
        type: 'bar',
        name: '銷量',
      };
      return chartData;
    },
    chartLabels() {
      const labels = this.mvmSalesSumByType.map((obj) => {
        this.loaded = true;
        return obj.AssetNo;
      });
      return labels;
    },
  },
  created() {},
  methods,
};
</script>
<style scoped>
.summaryTag {
  width: 80px;
  text-align: left;
}

::v-deep .cell {
  text-align: right;
}
</style>
